module.exports = __webpack_public_path__ + "woolworths-logo.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/woolworths-logo.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/woolworths-logo.png
// module chunks = 12